import MDBox from "components/MDBox";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getMyEvents, getTodayEvents, getUpcomingEvents, getPastEvents } from "services/contract";
import { useWallet } from "store/wallet";
import Slider from "../SinghDashboard/banner";
import { useMediaQuery } from "react-responsive";
import MDAvatar from "components/MDAvatar";
import { Card, CardMedia } from "@mui/material";
import SinghCoin from "./SinghCoin.png";
import MDTypography from "components/MDTypography";
import Loader from "loader/loader";
import Footer from "examples/Footer";
import TablePaginationCustom from "components/Pagination";
import { useSearchParams } from "react-router-dom";

export default function SeeAllEvents() {
  let navigate = useNavigate();
  let location = useLocation();
  const [searchParams] = useSearchParams();
  const { address } = useWallet();
  let eventsData;
  const [filteredEvents, setFilteredEvents] = useState([]);
  const [eventsLoading, setEventsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10); // Number of items per page
  const [totalPages, setTotalPages] = useState(0); // Total number of pages

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  useEffect(() => {
    fetchEvents();
    // eslint-disable-next-line
  }, [currentPage, rowsPerPage]);

  const fetchEvents = async () => {
    setEventsLoading(true);

    // Fetch based on the status query parameter
    if (searchParams.get("status") === "My Events") {
      eventsData = await getMyEvents(currentPage, rowsPerPage);
    } else if (searchParams.get("status") === "Ongoing Events") {
      eventsData = await getTodayEvents(currentPage, rowsPerPage);
    } else if (searchParams.get("status") === "Upcoming Events") {
      eventsData = await getUpcomingEvents(currentPage, rowsPerPage);
    } else if (searchParams.get("status") === "Past Events") {
      eventsData = await getPastEvents(currentPage, rowsPerPage);
    }
    console.log("##eventsData", eventsData);

    // Assuming `eventsData` has fields `data`, `totalEvents`, and `totalPages`
    if (eventsData.success) {
      setFilteredEvents(eventsData.data);
      setTotalPages(eventsData.totalEvents);
    } else {
      setFilteredEvents([]);
      setTotalPages(0);
    }
    setEventsLoading(false);
  };

  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(0); // Reset to first page
  };

  const handleEventDetails = (name, item) => {
    navigate(`/event-details/?eventDetails=${name}&tokenId=${item._id}`);
  };

  return (
    <>
      <DashboardNavbar />
      <Slider />
      <MDBox
        sx={{
          marginRight: isTabletOrMobile ? "5%" : "10%",
          marginLeft: isTabletOrMobile ? "5%" : "10%",
          marginBottom: "2rem",
        }}
      >
        <MDTypography variant="h3">{searchParams.get("status")}</MDTypography>
      </MDBox>
      <MDBox
        className="recentEventsHeader"
        sx={{
          display: "flex",
          gap: "2.5rem",
          justifyContent: "center",
          flexWrap: "wrap",
          marginRight: isTabletOrMobile ? "5%" : "10%",
          marginLeft: isTabletOrMobile ? "5%" : "10%",
        }}
      >
        {eventsLoading ? (
          <MDBox
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Loader />
          </MDBox>
        ) : (
          filteredEvents.map((item, idx) => (
            <Card
              key={idx}
              sx={{
                margin: 0,
                cursor: "pointer",
                width: "260px",
                height: "400px",
              }}
              onClick={() => handleEventDetails(searchParams.get("status"), item)}
            >
              <CardMedia
                sx={{ margin: 0, borderRadius: "10px 10px 0px 0px", objectFit: "fill" }}
                component="img"
                height="360"
                image={item.photo}
                alt="Event"
              />
              <MDBox
                sx={{
                  position: "absolute",
                  top: 10,
                  marginLeft: "5px",
                  width: "90px",
                  backgroundColor: "#000000",
                  opacity: "60%",
                  borderRadius: "15px",
                  textAlign: "center",
                }}
              >
                <MDTypography fontSize="small">{item.eventDate}</MDTypography>
              </MDBox>

              <MDBox sx={{ padding: 1 }}>
                <MDBox sx={{ display: "flex", justifyContent: "space-between" }}>
                  <MDBox
                    sx={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <MDBox marginLeft="4px" width="120px">
                      <MDTypography
                        fontWeight="bold"
                        fontSize="13px"
                        sx={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          width: "100px",
                        }}
                      >
                        {item.name}
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                  <MDBox
                    sx={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <MDAvatar src={SinghCoin} size="xs" />
                    <MDTypography color="white" fontWeight="bold" fontSize="small">
                      {item.price === "0" ? "Free" : Math.round(Number(item.price) * 100) / 100}
                    </MDTypography>
                  </MDBox>
                </MDBox>
              </MDBox>
            </Card>
          ))
        )}
      </MDBox>

      <TablePaginationCustom
        count={totalPages}
        page={currentPage}
        rowsPerPage={rowsPerPage}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
        dense
      />

      <Footer />
    </>
  );
}
